import { PeriscopeBaseRecord } from '../PeriscopeBaseRecord';
import { PeriscopePardotEmailTemplate } from './PeriscopePardotEmailTemplate';
import { PeriscopeSummary } from '../PeriscopeSummary';
import { SonarObjectType } from '../../../global';

export type PeriscopePardotEmailSummary = PeriscopeSummary;

export enum PeriscopePardotEmailState {
	Draft = 'Draft',
	Scheduled = 'Scheduled',
	Sent = 'Sent'
}
export type PeriscopePardotEmailMetadata = {
	bounce: string;
	contentType: string;
	emailTemplate?: PeriscopePardotEmailTemplate;
	published: string;
	replyTo: Array<string>;
	scheduledFor?: string;
	sender: Array<string>;
	sentAt?: string;
	state: PeriscopePardotEmailState;
	subject: string;
	type: string;
};

export type PeriscopePardotEmail = PeriscopeBaseRecord & {
	sonarObjectType: SonarObjectType;
};
